import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    width: "100%",
    padding: theme.spacing(2, 3),
    backgroundColor: "white",
    borderBottom: "1px solid #e5e5e7",
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
  },
  label: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#0A1A2F",
  },
  getMoreButton: {
    padding: theme.spacing(1, 3),
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    border: "none",
    borderRadius: "1rem",
    fontSize: "0.75rem",
    fontWeight: 500,
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));
